// CodeGeneratorJs.qunit.ts - QUnit tests for CPCBasic CodeGeneratorJs
//

import { BasicLexer } from "../BasicLexer";
import { BasicParser } from "../BasicParser";
import { CodeGeneratorJs } from "../CodeGeneratorJs";
import { Variables } from "../Variables";
import { TestHelper, TestsType, AllTestsType, ResultType } from "./TestHelper";
import { TestInput } from "./TestInput";

/* eslint-disable quote-props */
const allTests: AllTestsType = {
	numbers: {
		"a=1": " v.aR = 1;",
		"a=1.2": " v.aR = 1.2;",
		"a=-1.2": " v.aR = -1.2;",
		"a=+7.2": " v.aR = 7.2;",
		"a=&0": " v.aR = 0x0;",
		"a=&A7": " v.aR = 0xA7;",
		"a=-&A7": " v.aR = -(0xA7);",
		"a=&7FFF": " v.aR = 0x7FFF;",
		"a=&h0": " v.aR = 0x0;",
		"a=&H7FFF": " v.aR = 0x7FFF;",
		"a=&8000": " v.aR = -0x8000;",
		"a=&FFff": " v.aR = -0x1;",
		"a=&E123": " v.aR = -0x1edd;",
		"a=&HE123": " v.aR = -0x1edd;",
		"a=&X0": " v.aR = 0b0;",
		"a=&X10100111": " v.aR = 0b10100111;",
		"a=-&x111111111111111": " v.aR = -0b111111111111111;",
		"a=255": " v.aR = 255;",
		"a=-255": " v.aR = -255;",
		"a=256": " v.aR = 256;",
		"a=-256": " v.aR = -256;",
		"a=32767": " v.aR = 32767;",
		"a=-32767": " v.aR = -32767;",
		"a=32768": " v.aR = 32768;",
		"a=-32768": " v.aR = -32768;",
		"a=65536": " v.aR = 65536;",
		"a=1.2e+9": " v.aR = 1.2e+9;",
		"a=&": "BasicLexer: Expected hex number at pos 2-3: &",
		"a=&h": "BasicLexer: Expected hex number at pos 2-4: &h",
		"a=&x": "BasicLexer: Expected binary number at pos 2-4: &x",
		"a=&x2": "BasicLexer: Expected binary number at pos 2-4: &x",
		"a": "BasicParser: Expected = at pos 1: (end)",
		"1 a=": "BasicParser: Unexpected end of file in 1 at pos 4: ",
		"1 5=7": "BasicParser: Bad expression statement in 1 at pos 2-3: 5",
		"1 let 5=7": "BasicParser: Expected variable in 1 at pos 6-7: 5"
	},
	strings: {
		'a$="a12"': ' v.a$ = "a12";',
		'a$=+"7.1"': ' v.a$ = "7.1";',
		'a$="\\"': ' v.a$ = "\\\\";',
		'a$="unterminated string': ' v.a$ = "unterminated string";',
		'a$="string with\nnewline"': ' v.a$ = "string with\\x0anewline";',
		'a$="unterminated string with\nnewline=7': ' v.a$ = "unterminated string with\\x0anewline=7";',
		'1 a$="unterminated string\n2 newline=7': ' v.a$ = "unterminated string";\n v.newlineR = 7;'
	},
	variables: {
		"a!=1.4": " v.aR = 1.4;",
		"a%=1.4": " v.aI = o.vmRound(1.4);",
		'a$="1.4"': ' v.a$ = "1.4";',
		"case=1": " v.caseR = 1;",
		"CASE=1": " v.caseR = 1;",
		"CaSe=cAsE": " v.caseR = v.caseR;",
		"insert.line=2": " v.insert_lineR = 2;",
		"in.ser.t.lin.e=2": " v.in_ser_t_lin_eR = 2;",
		"a!(2)=1.4": " v.aAR[2] = 1.4;",
		"a%(2)=1.4": " v.aAI[2] = o.vmRound(1.4);",
		'a$(2)="1.4"': ' v.aA$[2] = "1.4";',
		'a$[2]="1.4"': ' v.aA$[2] = "1.4";',
		"a(9)=b(1,2)": " v.aAR[9] = v.bAAR[1][2];",
		"a[9]=b[1,2]": " v.aAR[9] = v.bAAR[1][2];",
		"a(10,10,10)=b(10,9)": " v.aAAAR[10][10][10] = v.bAAR[10][9];",
		"a!(1.4)=b!(1.5,2.4,1)": " v.aAR[o.vmRound(1.4)] = v.bAAAR[o.vmRound(1.5)][o.vmRound(2.4)][1];",
		"a!(b+1)=b!(a,a%*2,a%+1.5)": " v.aAR[o.vmRound(v.bR + 1)] = v.bAAAR[o.vmRound(v.aR)][v.aI * 2][o.vmRound(v.aI + 1.5)];",
		"a!(b+1)=b!(int(a),a%*2,a%-1+&d)": " v.aAR[o.vmRound(v.bR + 1)] = v.bAAAR[o.int(v.aR)][v.aI * 2][(v.aI - 1) + 0xd];",
		"1 a$=a%": "CodeGeneratorJs: Type error in 1 at pos 4-5: =",
		"1 a$=a!": "CodeGeneratorJs: Type error in 1 at pos 4-5: =",
		"1 abc=def": "BasicParser: Unexpected token in 1 at pos 6-9: def"
	},
	expressions: {
		"a=1+2+3": " v.aR = (1 + 2) + 3;",
		"a=3-2-1:": " v.aR = (3 - 2) - 1;",
		"a=&A7+&X10100111-(123-27)": " v.aR = (0xA7 + 0b10100111) - (123 - 27);",
		"a=(3+2)*(3-7)": " v.aR = (3 + 2) * (3 - 7);",
		"a=-(10-7)-(-6-2)": " v.aR = -(10 - 7) - (-6 - 2);",
		"a=20/2.5": " v.aR = 20 / 2.5;",
		"a=20\\3": " v.aR = (20 / 3) | 0;",
		"a=3^2:": " v.aR = Math.pow(3, 2);",
		"a=&X1001 AND &X1110": " v.aR = 0b1001 & 0b1110;",
		"a=&X1001 OR &X110": " v.aR = 0b1001 | 0b110;",
		"a=&X1001 XOR &X1010": " v.aR = 0b1001 ^ 0b1010;",
		"a=NOT &X1001": " v.aR = ~(0b1001);",
		"a=+++++++++---9": " v.aR = -9;",
		"a=(1=0)": " v.aR = 1 === 0 ? -1 : 0;",
		"a=(1>0)*(0<1)": " v.aR = (1 > 0 ? -1 : 0) * (0 < 1 ? -1 : 0);",
		"a=(b%>=c%)*(d<=e)": " v.aR = (v.bI >= v.cI ? -1 : 0) * (v.dR <= v.eR ? -1 : 0);",
		"a=1=1=-1": " v.aR = (1 === 1 ? -1 : 0) === -1 ? -1 : 0;",
		"a=1>=1>1": " v.aR = (1 >= 1 ? -1 : 0) > 1 ? -1 : 0;"
	},
	"Line numbers": {
		"1": "",
		"0 cls": "CodeGeneratorJs: Line number overflow in 0 at pos 0-1: 0",
		"65535 cls": " o.cls(0);",
		"65536 cls": "CodeGeneratorJs: Line number overflow in 0 at pos 0-5: 65536",
		"1.2 cls": "CodeGeneratorJs: Expected integer line number in 0 at pos 0-3: 1.2",
		"2 cls\n1 cls": "CodeGeneratorJs: Expected increasing line number in 0 at pos 6-7: 1"
	},
	special: {
		"!": "BasicLexer: Unrecognized token at pos 0-1: !",
		"inkey!": "BasicLexer: Invalid identifier at pos 0-6: inkey!",
		"inkey%": "BasicLexer: Invalid identifier at pos 0-6: inkey%",
		"key$": "BasicLexer: Invalid identifier at pos 0-4: key$",
		"key!": "BasicLexer: Invalid identifier at pos 0-4: key!",
		"key%": "BasicLexer: Invalid identifier at pos 0-4: key%"
	},
	"abs, after gosub, and, asc, atn, auto": {
		"a=abs(2.3)": " v.aR = o.abs(2.3);",
		"10 after 2 gosub 10": " o.afterGosub(2, undefined, 10);",
		"10 after 3,1 gosub 10": " o.afterGosub(3, 1, 10);",
		"1 after gosub 1": "BasicParser: Unexpected token in 1 at pos 8-13: gosub",
		"1 after 1,2,3 gosub 1": "BasicParser: Expected end of arguments in 1 at pos 11-12: ,",
		"a=b and c": " v.aR = o.vmRound(v.bR) & o.vmRound(v.cR);",
		'a=asc("A")': ' v.aR = o.asc("A");',
		"a!=asc(b$) and c%": " v.aR = o.asc(v.b$) & v.cI;",
		"a=atn(2.3)": " v.aR = o.atn(2.3);",
		"auto": " o.auto();",
		"auto 100": " o.auto(100);"
	},
	"bin$, border": {
		"a$=bin$(3)": " v.a$ = o.bin$(3);",
		"a$=bin$(3,8)": " v.a$ = o.bin$(3, 8);",
		"a$=bin$(&x1001)": " v.a$ = o.bin$(0b1001);",
		"border 5": " o.border(5);",
		"border 5,a": " o.border(5, v.aR);"
	},
	"call, cat, chain, chain merge, chr$, cint, clg, closein, closeout, cls, cont, copychr$, cos, creal, cursor": {
		"call&a7bc": ' o.call(-0x5844); o.vmGoto("directs0"); break;\ncase "directs0":',
		"call 4711,1,2,3,4": ' o.call(4711, 1, 2, 3, 4); o.vmGoto("directs0"); break;\ncase "directs0":',
		"cat": " o.cat();",
		'chain"f1"': ' o.chain("f1"); o.vmGoto("directs0"); break;\ncase "directs0":',
		'chain"f2" , 10': ' o.chain("f2", 10); o.vmGoto("directs0"); break;\ncase "directs0":',
		'chain"f3" , 10+3': ' o.chain("f3", 10 + 3); o.vmGoto("directs0"); break;\ncase "directs0":',
		'chain "f4" , 10+3, delete 100-200': ' o.chain("f4", 10 + 3, 100, 200); o.vmGoto("directs0"); break;\ncase "directs0":',
		'chain "f5" , , delete 100-200': ' o.chain("f5", undefined, 100, 200); o.vmGoto("directs0"); break;\ncase "directs0":',
		'chain merge "f1"': ' o.chainMerge("f1"); o.vmGoto("directs0"); break;\ncase "directs0":',
		'chain merge "f2" , 10': ' o.chainMerge("f2", 10); o.vmGoto("directs0"); break;\ncase "directs0":',
		'chain merge "f3" , 10+3': ' o.chainMerge("f3", 10 + 3); o.vmGoto("directs0"); break;\ncase "directs0":',
		'chain merge "f4" , 10+3, delete 100-200': ' o.chainMerge("f4", 10 + 3, 100, 200); o.vmGoto("directs0"); break;\ncase "directs0":',
		'chain merge "f5" , , delete 100-200': ' o.chainMerge("f5", undefined, 100, 200); o.vmGoto("directs0"); break;\ncase "directs0":',
		"a=chr$(65)": "CodeGeneratorJs: Type error in direct at pos 1-2: =",
		"a=cint(2.3)": " v.aR = o.cint(2.3);",
		"clear": ' o.clear(); o.vmGoto("directs0"); break;\ncase "directs0":',
		"clear input": " o.clearInput();",
		"clg": " o.clg();",
		"clg 15-1": " o.clg(15 - 1);",
		"closein": " o.closein();",
		"closeout": ' o.closeout(); o.vmGoto("directs0"); break;\ncase "directs0":',
		"cls": " o.cls(0);",
		"cls #5": " o.cls(5);",
		"cls #a+7-2*b": " o.cls((v.aR + 7) - (2 * v.bR));",
		"cont": " o.cont(); break;",
		"a$=copychr$(#0)": " v.a$ = o.copychr$(0);",
		"a$=copychr$(#a+1)": " v.a$ = o.copychr$(v.aR + 1);",
		"a=cos(2.3)": " v.aR = o.cos(2.3);",
		"a=creal(2.3+a)": " v.aR = o.creal(2.3 + v.aR);",
		"cursor": " o.cursor(0);",
		"cursor 0": " o.cursor(0, 0);",
		"cursor 1": " o.cursor(0, 1);",
		"cursor 1,1": " o.cursor(0, 1, 1);",
		"cursor ,1": " o.cursor(0, undefined, 1);",
		"cursor #2": " o.cursor(2);",
		"cursor #2,1": " o.cursor(2, 1);",
		"cursor #2,1,1": " o.cursor(2, 1, 1);",
		"cursor #2,,1": " o.cursor(2, undefined, 1);"
	},
	"data, dec$, def fn, defint, defreal, defstr, deg, delete, derr, di, dim, draw, drawr": {
		"data": 'o.data("direct", undefined);\n /* data */;',
		"data ,": 'o.data("direct", undefined, undefined);\n /* data */;',
		"data \\": 'o.data("direct", "\\\\");\n /* data */;',
		"data 1,2,3": 'o.data("direct", "1", "2", "3");\n /* data */;',
		'data "item1"," item2","item3 "': 'o.data("direct", "item1", " item2", "item3 ");\n /* data */;',
		"data item1,item2,item3": 'o.data("direct", "item1", "item2", "item3");\n /* data */;',
		"data &a3,4,abc,": 'o.data("direct", "&a3", "4", "abc", undefined);\n /* data */;',
		'data " ",!"#$%&\'()*+,","': 'o.data("direct", " ", "!\\"#$%&\'()*+", ",");\n /* data */;',
		'data "string in data with\nnewline"': 'o.data("direct", "string in data with\\x0anewline");\n /* data */;',
		'a$=dec$(3,"##.##")': ' v.a$ = o.dec$(3, "##.##");',
		"def fnclk=10": " v.fnclkR = function () { return 10; };",
		"def fnclk(a)=a*10": ' v.fnclkR = function (a) { return o.vmAssign("fR", a * 10); };',
		"def fnclk(a,b)=a*10+b": ' v.fnclkR = function (a, b) { return o.vmAssign("fR", (a * 10) + b); };',
		"def fnclk$(a$,b$)=a$+b$": " v.fnclk$ = function (a$, b$) { return a$ + b$; };",
		"def fn clk=10": " v.fnclkR = function () { return 10; };",
		"def fn clk(a)=a*10": ' v.fnclkR = function (a) { return o.vmAssign("fR", a * 10); };',
		"def fn clk(a,b)=a*10+b": ' v.fnclkR = function (a, b) { return o.vmAssign("fR", (a * 10) + b); };',
		"def fn clk$(a$,b$)=a$+b$": " v.fnclk$ = function (a$, b$) { return a$ + b$; };",
		"def fno(o,t,v,do)=o+t+v+do+go": ' v.fnoR = function (No, Nt, Nv, _do) { return o.vmAssign("fR", (((No + Nt) + Nv) + _do) + v.goR); };',
		"def fncls=1": "BasicParser: Expected identifier at pos 6-9: cls",
		"def fncls1(x+1)=1": "BasicParser: Expected variable at pos 12-13: +",
		"def fx=1": "BasicParser: Expected fn at pos 4-6: fx",
		"def fx y=1": "BasicParser: Expected fn at pos 4-6: fx",
		"defint a": ' o.defint("a");',
		"defint a-t": ' o.defint("a", "t");',
		"defint a-T": ' o.defint("a", "t");',
		"defint a,b,c": ' o.defint("a"); o.defint("b"); o.defint("c");',
		"defint a,b-c,v,x-y": ' o.defint("a"); o.defint("b", "c"); o.defint("v"); o.defint("x", "y");',
		"defint a:b=a+c": ' o.defint("a"); v.bR = o.vmAssign("bR", v["a" + t.a] + v.cR);',
		"defint a:a=a+1": ' o.defint("a"); v["a" + t.a] = o.vmAssign("a", v["a" + t.a] + 1);',
		'defint a:a!=a!+a%:a$="7"': ' o.defint("a"); v.aR = v.aR + v.aI; v.a$ = "7";',
		"defint a:ab=ab+de[7]": ' o.defint("a"); v["ab" + t.a] = o.vmAssign("a", v["ab" + t.a] + v.deAR[7]);',
		"1 defint z-a": "CodeGeneratorJs: Decreasing range in 1 at pos 10-11: -",
		"defreal a": ' o.defreal("a");',
		"defreal a-t": ' o.defreal("a", "t");',
		"defreal a-T": ' o.defreal("a", "t");',
		"defreal a,b,c": ' o.defreal("a"); o.defreal("b"); o.defreal("c");',
		"defreal a,b-c,v,x-y": ' o.defreal("a"); o.defreal("b", "c"); o.defreal("v"); o.defreal("x", "y");',
		"defreal a:b=a+c": ' o.defreal("a"); v.bR = v.aR + v.cR;',
		"defreal a:a=a+1": ' o.defreal("a"); v.aR = v.aR + 1;',
		'defreal a:a!=a!+a%:a$="7"': ' o.defreal("a"); v.aR = v.aR + v.aI; v.a$ = "7";',
		"defreal a:ab=ab+de[7]": ' o.defreal("a"); v.abR = v.abR + v.deAR[7];',
		"1 defreal z-a": "CodeGeneratorJs: Decreasing range in 1 at pos 11-12: -",
		"defstr a": ' o.defstr("a");',
		"defstr a-t": ' o.defstr("a", "t");',
		"defstr a-T": ' o.defstr("a", "t");',
		"defstr a,b,c": ' o.defstr("a"); o.defstr("b"); o.defstr("c");',
		"defstr a,b-c,v,x-y": ' o.defstr("a"); o.defstr("b", "c"); o.defstr("v"); o.defstr("x", "y");',
		"defstr a:b=a+c": ' o.defstr("a"); v.bR = o.vmAssign("bR", v["a" + t.a] + v.cR);',
		"defstr a:a=a+1": ' o.defstr("a"); v["a" + t.a] = o.vmAssign("a", v["a" + t.a] + 1);',
		'defstr a:a!=a!+a%:a$="7"': ' o.defstr("a"); v.aR = v.aR + v.aI; v.a$ = "7";',
		"defstr a:ab=ab+de[7]": ' o.defstr("a"); v["ab" + t.a] = o.vmAssign("a", v["ab" + t.a] + v.deAR[7]);',
		"1 defstr z-a": "CodeGeneratorJs: Decreasing range in 1 at pos 10-11: -",
		'defstr f:f(x)="w"': ' o.defstr("f"); v["fA" + t.f][o.vmRound(v.xR)] = o.vmAssign("f", "w");',
		"deg": " o.deg();",
		"delete": " o.delete(1, 65535); break;",
		"delete -": " o.delete(undefined, 65535); break;",
		"delete ,": " o.delete(undefined); break;",
		"delete -,": " o.delete(undefined, 65535); break;",
		"delete 10": " o.delete(10); break;",
		"delete 1-": " o.delete(1, 65535); break;",
		"delete -1": " o.delete(undefined, 1); break;",
		"delete 1-2": " o.delete(1, 2); break;",
		"1 delete 2-1": "CodeGeneratorJs: Decreasing line range in 1 at pos 10-11: -",
		"1 delete 1+2": "BasicParser: Expected : in 1 at pos 10-11: +",
		"1 delete a": "BasicParser: Expected : in 1 at pos 9-10: a",
		"a=derr": " v.aR = o.derr();",
		"di": " o.di();",
		"dim a(1)": ' /* v.aAR[1] = */ o.dim("aAR", 1);',
		"dim a!(1)": ' /* v.aAR[1] = */ o.dim("aAR", 1);',
		"dim a%(1)": ' /* v.aAI[1] = */ o.dim("aAI", 1);',
		"dim a$(1)": ' /* v.aA$[1] = */ o.dim("aA$", 1);',
		"dim a(2,13)": ' /* v.aAAR[2][13] = */ o.dim("aAAR", 2, 13);',
		"dim a(2,13+7),b$[3],c![2*a,7]": ' /* v.aAAR[2][13 + 7] = */ o.dim("aAAR", 2, 13 + 7); /* v.bA$[3] = */ o.dim("bA$", 3); /* v.cAAR[o.vmRound(2 * v.aR)][7] = */ o.dim("cAAR", 2 * v.aR, 7);',
		"dim a[2,13)": ' /* v.aAAR[2][13] = */ o.dim("aAAR", 2, 13);',
		"draw 10,20": " o.draw(10, 20);",
		"draw -10,-20,7": " o.draw(-10, -20, 7);",
		"draw 10,20,7,3": " o.draw(10, 20, 7, 3);",
		"draw 10,20,,3": " o.draw(10, 20, undefined, 3);",
		"draw x,y,m,g1": " o.draw(v.xR, v.yR, v.mR, v.g1R);",
		"drawr 10,20": " o.drawr(10, 20);",
		"drawr -10,-20,7": " o.drawr(-10, -20, 7);",
		"drawr 10,20,7,3": " o.drawr(10, 20, 7, 3);",
		"drawr 10,20,,3": " o.drawr(10, 20, undefined, 3);",
		"drawr x,y,m,g1": " o.drawr(v.xR, v.yR, v.mR, v.g1R);"
	},
	"edit, ei, else, end, ent, env, eof, erase, erl, err, error, every gosub, exp": {
		"edit 20": " o.edit(20); break;",
		"ei": " o.ei();",
		"else": " // else",
		"else 10": " // else 10",
		"else a=7": " // else a = 7",
		"end": ' o.end("directs0"); break;\ncase "directs0":',
		"ent 1": " o.ent(1);",
		"ent 1,2,a,4": " o.ent(1, 2, v.aR, 4);",
		"ent num,steps,dist,ti,steps2,dist2,ti2": " o.ent(v.numR, v.stepsR, v.distR, v.tiR, v.steps2R, v.dist2R, v.ti2R);",
		"ent num,=period,ti,=period2,ti2": " o.ent(v.numR, undefined, v.periodR, v.tiR, undefined, v.period2R, v.ti2R);",
		"env 1": " o.env(1);",
		"env 1,2,a,4": " o.env(1, 2, v.aR, 4);",
		"env num,steps,dist,ti,steps2,dist2,ti2": " o.env(v.numR, v.stepsR, v.distR, v.tiR, v.steps2R, v.dist2R, v.ti2R);",
		"env num,=reg,period,=reg2,period2": " o.env(v.numR, undefined, v.regR, v.periodR, undefined, v.reg2R, v.period2R);",
		"a=eof": " v.aR = o.eof();",
		"erase a": ' o.erase("a");',
		"erase b$": ' o.erase("b$");',
		"erase a,b$,c!,d%": ' o.erase("a", "b$", "cR", "dI");',
		"erase o,t,v,do": ' o.erase("o", "t", "v", "do");',
		"1 erase 5": "BasicParser: Expected variable in 1 at pos 8-9: 5",
		"a=erl": " v.aR = o.erl();",
		"a=err": " v.aR = o.err();",
		"error 7": " o.error(7); break;",
		"error 5+a": " o.error(5 + v.aR); break;",
		"10 every 50 gosub 10": " o.everyGosub(50, undefined, 10);",
		"10 every 25.2,1 gosub 10": " o.everyGosub(25.2, 1, 10);",
		"10 every 10+a,b gosub 10": " o.everyGosub(10 + v.aR, v.bR, 10);",
		"a=exp(2.3)": " v.aR = o.exp(2.3);"
	},
	"fill, fix, fn, for, frame, fre": {
		"fill 7": " o.fill(7);",
		"a=fix(2.3)": " v.aR = o.fix(2.3);",
		"x=fnclk": " v.xR = v.fnclkR();",
		"x=fnclk(a)": " v.xR = v.fnclkR(v.aR);",
		"x=fnclk(a,b)": " v.xR = v.fnclkR(v.aR, v.bR);",
		"x$=fnclk$(a$,b$)": " v.x$ = v.fnclk$(v.a$, v.b$);",
		"x=fn clk": " v.xR = v.fnclkR();",
		"x=fn clk(a)": " v.xR = v.fnclkR(v.aR);",
		"x=fn clk(a,b)": " v.xR = v.fnclkR(v.aR, v.bR);",
		"x$=fn clk$(a$,b$)": " v.x$ = v.fnclk$(v.a$, v.b$);",
		"for a=1 to 10": ' /* for() */ v.aR = 1; o.vmGoto("directf0b"); break;\ncase "directf0": v.aR += 1;\ncase "directf0b": if (v.aR > 10) { o.vmGoto("directf0e"); break; }',
		"for a%=1.5 to 9.5": ' /* for() */ v.aI = o.vmAssign("aI", 1.5); v.aIEnd = o.vmAssign("aI", 9.5); o.vmGoto("directf0b"); break;\ncase "directf0": v.aI += 1;\ncase "directf0b": if (v.aI > v.aIEnd) { o.vmGoto("directf0e"); break; }',
		"for a!=1.5 to 9.5": ' /* for() */ v.aR = o.vmAssign("aR", 1.5); v.aREnd = o.vmAssign("aR", 9.5); o.vmGoto("directf0b"); break;\ncase "directf0": v.aR += 1;\ncase "directf0b": if (v.aR > v.aREnd) { o.vmGoto("directf0e"); break; }',
		"for a=1 to 10 step 3": ' /* for() */ v.aR = 1; o.vmGoto("directf0b"); break;\ncase "directf0": v.aR += 3;\ncase "directf0b": if (v.aR > 10) { o.vmGoto("directf0e"); break; }',
		"for a=5+b to -4 step -2.3": ' /* for() */ v.aR = o.vmAssign("aR", 5 + v.bR); v.aRStep = o.vmAssign("aR", -2.3); o.vmGoto("directf0b"); break;\ncase "directf0": v.aR += v.aRStep;\ncase "directf0b": if (v.aRStep > 0 && v.aR > -4 || v.aRStep < 0 && v.aR < -4 || !v.aRStep && v.aR === -4) { o.vmGoto("directf0e"); break; }',
		"for a=b to c step d": ' /* for() */ v.aR = o.vmAssign("aR", v.bR); v.aREnd = o.vmAssign("aR", v.cR); v.aRStep = o.vmAssign("aR", v.dR); o.vmGoto("directf0b"); break;\ncase "directf0": v.aR += v.aRStep;\ncase "directf0b": if (v.aRStep > 0 && v.aR > v.aREnd || v.aRStep < 0 && v.aR < v.aREnd || !v.aRStep && v.aR === v.aREnd) { o.vmGoto("directf0e"); break; }',
		"for a=b% to c%": ' /* for() */ v.aR = v.bI; v.aREnd = v.cI; o.vmGoto("directf0b"); break;\ncase "directf0": v.aR += 1;\ncase "directf0b": if (v.aR > v.aREnd) { o.vmGoto("directf0e"); break; }',
		"for a=1 to 1 step 0": ' /* for() */ v.aR = 1; o.vmGoto("directf0b"); break;\ncase "directf0": v.aR += 0;\ncase "directf0b": if (v.aR === 1) { o.vmGoto("directf0e"); break; }',
		"for a=b to c step s": ' /* for() */ v.aR = o.vmAssign("aR", v.bR); v.aREnd = o.vmAssign("aR", v.cR); v.aRStep = o.vmAssign("aR", v.sR); o.vmGoto("directf0b"); break;\ncase "directf0": v.aR += v.aRStep;\ncase "directf0b": if (v.aRStep > 0 && v.aR > v.aREnd || v.aRStep < 0 && v.aR < v.aREnd || !v.aRStep && v.aR === v.aREnd) { o.vmGoto("directf0e"); break; }',
		"for a=1 to 2 step 0": ' /* for() */ v.aR = 1; o.vmGoto("directf0b"); break;\ncase "directf0": v.aR += 0;\ncase "directf0b": if (v.aR === 2) { o.vmGoto("directf0e"); break; }',
		"for a=-1 to -2 step 0": ' /* for() */ v.aR = -1; o.vmGoto("directf0b"); break;\ncase "directf0": v.aR += 0;\ncase "directf0b": if (v.aR === -2) { o.vmGoto("directf0e"); break; }',
		"for a=&a000 TO &ha00b step &x101": ' /* for() */ v.aR = -0x6000; o.vmGoto("directf0b"); break;\ncase "directf0": v.aR += 0b101;\ncase "directf0b": if (v.aR > -0x5ff5) { o.vmGoto("directf0e"); break; }',
		"for a=2 to 1 step -&1": ' /* for() */ v.aR = 2; o.vmGoto("directf0b"); break;\ncase "directf0": v.aR += -0x1;\ncase "directf0b": if (v.aR < 1) { o.vmGoto("directf0e"); break; }',
		"for a=2 to 1 step -&x1": ' /* for() */ v.aR = 2; o.vmGoto("directf0b"); break;\ncase "directf0": v.aR += -0b1;\ncase "directf0b": if (v.aR < 1) { o.vmGoto("directf0e"); break; }',
		"1 for a$=1 to 2": "CodeGeneratorJs: Type error in 1 at pos 6-8: a$",
		"defint a:for abc=1 to 10 step 3:next abc": ' o.defint("a"); /* for() */ o.vmAssertNumberType("a"); v["abc" + t.a] = 1; o.vmGoto("directf0b"); break;\ncase "directf0": v["abc" + t.a] += 3;\ncase "directf0b": if (v["abc" + t.a] > 10) { o.vmGoto("directf0e"); break; } /* next("v["abc" + t.a]") */ o.vmGoto("directf0"); break;\ncase "directf0e":',
		"defstr a:for abc=1 to 10 step 3:next abc": ' o.defstr("a"); /* for() */ o.vmAssertNumberType("a"); v["abc" + t.a] = 1; o.vmGoto("directf0b"); break;\ncase "directf0": v["abc" + t.a] += 3;\ncase "directf0b": if (v["abc" + t.a] > 10) { o.vmGoto("directf0e"); break; } /* next("v["abc" + t.a]") */ o.vmGoto("directf0"); break;\ncase "directf0e":',
		"for a=b to c step s:defint a-b:a=0:defreal a:next": ' /* for() */ o.vmAssertNumberType("a"); v["a" + t.a] = o.vmAssign("a", v["b" + t.b]); v.aEnd = o.vmAssign("a", v.cR); v.aStep = o.vmAssign("a", v.sR); o.vmGoto("directf0b"); break;\ncase "directf0": v["a" + t.a] += v.aStep;\ncase "directf0b": if (v.aStep > 0 && v["a" + t.a] > v.aEnd || v.aStep < 0 && v["a" + t.a] < v.aEnd || !v.aStep && v["a" + t.a] === v.aEnd) { o.vmGoto("directf0e"); break; } o.defint("a", "b"); v["a" + t.a] = o.vmAssign("a", 0); o.defreal("a"); /* next("") */ o.vmGoto("directf0"); break;\ncase "directf0e":',
		"frame": ' o.frame(); o.vmGoto("directs0"); break;\ncase "directs0":',
		"a=fre(0)": " v.aR = o.fre(0);",
		'a=fre("")': ' v.aR = o.fre("");',
		"a=fre(b-2)": " v.aR = o.fre(v.bR - 2);",
		"a=fre(a$)": " v.aR = o.fre(v.a$);"
	},
	"gosub, goto, graphics paper, graphics pen": {
		"10 gosub 10": ' o.gosub("10g0", 10); break;\ncase "10g0":',
		"1 gosub a": "BasicParser: Expected line number in 1 at pos 8-9: a",
		"10 goto 10": " o.goto(10); break;",
		"1 goto a": "BasicParser: Expected line number in 1 at pos 7-8: a",
		"graphics paper 5": " o.graphicsPaper(5);",
		"graphics paper 2.3*a": " o.graphicsPaper(2.3 * v.aR);",
		"graphics pen 5": " o.graphicsPen(5);",
		"graphics pen 5,1": " o.graphicsPen(5, 1);",
		"graphics pen ,0": " o.graphicsPen(undefined, 0);",
		"graphics pen 2.3*a,1+b": " o.graphicsPen(2.3 * v.aR, 1 + v.bR);"
	},
	"hex$, himem": {
		"a$=hex$(16)": " v.a$ = o.hex$(16);",
		"a$=hex$(16,4)": " v.a$ = o.hex$(16, 4);",
		"a$=hex$(a,b)": " v.a$ = o.hex$(v.aR, v.bR);",
		"a=himem": ' v.aR = o.vmAssign("aR", o.himem());'
	},
	"if, ink, inkey, inkey$, inp, input, instr, int": {
		"if a=1 then a=2": " if (v.aR === 1) { v.aR = 2; }",
		"if a=1 then a=2 else a=1": " if (v.aR === 1) { v.aR = 2; } else { v.aR = 1; }",
		"if a=1 then": " if (v.aR === 1) { ; }",
		"if a=1 then else": " if (v.aR === 1) { ; }",
		"if a=1 then a=2 else": " if (v.aR === 1) { v.aR = 2; }",
		"if a=1 then else a=1": " if (v.aR === 1) { ; } else { v.aR = 1; }",
		"if a=1 then if b=1 then else else a=1": " if (v.aR === 1) { if (v.bR === 1) { ; }; } else { v.aR = 1; }",
		"10 if a=1 then goto 10": " if (v.aR === 1) { o.goto(10); break; }",
		"10 if a=1 then 10": " if (v.aR === 1) { o.goto(10); break; }",
		"10 if a=1 goto 10": " if (v.aR === 1) { o.goto(10); break; }",
		"10 if a=1 then a=a+1:goto 10": " if (v.aR === 1) { v.aR = v.aR + 1; o.goto(10); break; }",
		"10 if a=1 then gosub 10": ' if (v.aR === 1) { o.vmGoto("10i0"); break; } o.vmGoto("10i0e"); break;\ncase "10i0": o.gosub("10g0", 10); break;\ncase "10g0":;\ncase "10i0e": ;',
		"10 if a=1 then 10:a=never1": ' if (v.aR === 1) { o.vmGoto("10i0"); break; } o.vmGoto("10i0e"); break;\ncase "10i0": o.goto(10); break; v.aR = v.never1R;\ncase "10i0e": ;',
		"10 if a=1 then 10 else 20\n20 rem": " if (v.aR === 1) { o.goto(10); break; } else { o.goto(20); break; }\n //",
		"10 if a=1 then 10 else goto 20\n20 rem": " if (v.aR === 1) { o.goto(10); break; } else { o.goto(20); break; }\n //",
		"10 if a=b+5*c then a=a+1: goto 10 else a=a-1:goto 20\n20 rem": " if (v.aR === (v.bR + (5 * v.cR))) { v.aR = v.aR + 1; o.goto(10); break; } else { v.aR = v.aR - 1; o.goto(20); break; }\n //",
		"10 if a%<>3 then 10": " if (v.aI !== 3) { o.goto(10); break; }",
		'10 if a$<>"3" then 10': ' if (v.a$ !== "3") { o.goto(10); break; }',
		"ink 2,19": " o.ink(2, 19);",
		"ink 2,19,22": " o.ink(2, 19, 22);",
		"ink a*2,b-1,c": " o.ink(v.aR * 2, v.bR - 1, v.cR);",
		"a=inkey(0)": " v.aR = o.inkey(0);",
		"a$=inkey$": " v.a$ = o.inkey$();",
		"a=inp(&ff77)": " v.aR = o.inp(-0x89);",
		"input a$": ' o.vmGoto("directs0"); break;\ncase "directs0":o.input(0, undefined, "? ", "a$"); o.vmGoto("directs1"); break;\ncase "directs1":; v.a$ = o.vmGetNextInput();',
		"input a$,b": ' o.vmGoto("directs0"); break;\ncase "directs0":o.input(0, undefined, "? ", "a$", "bR"); o.vmGoto("directs1"); break;\ncase "directs1":; v.a$ = o.vmGetNextInput(); v.bR = o.vmGetNextInput();',
		"input ;a$,b": ' o.vmGoto("directs0"); break;\ncase "directs0":o.input(0, ";", "? ", "a$", "bR"); o.vmGoto("directs1"); break;\ncase "directs1":; v.a$ = o.vmGetNextInput(); v.bR = o.vmGetNextInput();',
		'input "para",a$,b': ' o.vmGoto("directs0"); break;\ncase "directs0":o.input(0, undefined, "para", "a$", "bR"); o.vmGoto("directs1"); break;\ncase "directs1":; v.a$ = o.vmGetNextInput(); v.bR = o.vmGetNextInput();',
		'input "para";a$,b': ' o.vmGoto("directs0"); break;\ncase "directs0":o.input(0, undefined, "para? ", "a$", "bR"); o.vmGoto("directs1"); break;\ncase "directs1":; v.a$ = o.vmGetNextInput(); v.bR = o.vmGetNextInput();',
		'input ;"para noCRLF";a$,b': ' o.vmGoto("directs0"); break;\ncase "directs0":o.input(0, ";", "para noCRLF? ", "a$", "bR"); o.vmGoto("directs1"); break;\ncase "directs1":; v.a$ = o.vmGetNextInput(); v.bR = o.vmGetNextInput();',
		'input#2,;"para noCRLF";a$,b': ' o.vmGoto("directs0"); break;\ncase "directs0":o.input(2, ";", "para noCRLF? ", "a$", "bR"); o.vmGoto("directs1"); break;\ncase "directs1":; v.a$ = o.vmGetNextInput(); v.bR = o.vmGetNextInput();',
		'input#stream,;"string";a$,b': ' o.vmGoto("directs0"); break;\ncase "directs0":o.input(v.streamR, ";", "string? ", "a$", "bR"); o.vmGoto("directs1"); break;\ncase "directs1":; v.a$ = o.vmGetNextInput(); v.bR = o.vmGetNextInput();',
		'a=instr("key","ey")': ' v.aR = o.instr("key", "ey");',
		"a=instr(s$,find$)": " v.aR = o.instr(v.s$, v.find$);",
		"a=instr(start,s$,find$)": " v.aR = o.instr(v.startR, v.s$, v.find$);",
		"a=int(-2.3)": " v.aR = o.int(-2.3);",
		"a=int(b+2.3)": " v.aR = o.int(v.bR + 2.3);"
	},
	joy: {
		"a=joy(0)": " v.aR = o.joy(0);",
		"a=joy(b+1)": " v.aR = o.joy(v.bR + 1);"
	},
	"key, key def": {
		'key 11,"border 13:paper 0"': ' o.key(11, "border 13:paper 0");',
		"key a,b$": " o.key(v.aR, v.b$);",
		"key def 68,1": " o.keyDef(68, 1);",
		"key def 68,1,159": " o.keyDef(68, 1, 159);",
		"key def 68,1,159,160": " o.keyDef(68, 1, 159, 160);",
		"key def 68,1,159,160,161": " o.keyDef(68, 1, 159, 160, 161);",
		"key def num,fire,normal,shift,ctrl": " o.keyDef(v.numR, v.fireR, v.normalR, v.shiftR, v.ctrlR);"
	},
	"left$, len, let, line input, list, load, locate, log, log10, lower$": {
		"a$=left$(b$,n)": " v.a$ = o.left$(v.b$, v.nR);",
		"a=len(a$)": " v.aR = o.len(v.a$);",
		"let a=a+1": " v.aR = v.aR + 1;",
		"line input a$": ' o.vmGoto("directs0"); break;\ncase "directs0":o.lineInput(0, undefined, "? ", "a$"); o.vmGoto("directs1"); break;\ncase "directs1":; v.a$ = o.vmGetNextInput();',
		"line input ;a$": ' o.vmGoto("directs0"); break;\ncase "directs0":o.lineInput(0, ";", "? ", "a$"); o.vmGoto("directs1"); break;\ncase "directs1":; v.a$ = o.vmGetNextInput();',
		'line input "para",a$': ' o.vmGoto("directs0"); break;\ncase "directs0":o.lineInput(0, undefined, "para", "a$"); o.vmGoto("directs1"); break;\ncase "directs1":; v.a$ = o.vmGetNextInput();',
		'line input "para";a$': ' o.vmGoto("directs0"); break;\ncase "directs0":o.lineInput(0, undefined, "para? ", "a$"); o.vmGoto("directs1"); break;\ncase "directs1":; v.a$ = o.vmGetNextInput();',
		'line input ;"para noCRLF";a$': ' o.vmGoto("directs0"); break;\ncase "directs0":o.lineInput(0, ";", "para noCRLF? ", "a$"); o.vmGoto("directs1"); break;\ncase "directs1":; v.a$ = o.vmGetNextInput();',
		'line input#2,;"para noCRLF";a$': ' o.vmGoto("directs0"); break;\ncase "directs0":o.lineInput(2, ";", "para noCRLF? ", "a$"); o.vmGoto("directs1"); break;\ncase "directs1":; v.a$ = o.vmGetNextInput();',
		'line input#stream,;"string";a$': ' o.vmGoto("directs0"); break;\ncase "directs0":o.lineInput(v.streamR, ";", "string? ", "a$"); o.vmGoto("directs1"); break;\ncase "directs1":; v.a$ = o.vmGetNextInput();',
		"list": " o.list(0); break;",
		"list -": " o.list(0, undefined, 65535); break;",
		"list ,": " o.list(0, undefined); break;",
		"list -,": " o.list(0, undefined, 65535); break;",
		"list 10": " o.list(0, 10); break;",
		"list 1-": " o.list(0, 1, 65535); break;",
		"list -1": " o.list(0, undefined, 1); break;",
		"list 1-2": " o.list(0, 1, 2); break;",
		"list #3": " o.list(3, undefined); break;",
		"list ,#3": " o.list(3, undefined); break;",
		"list 10,#3": " o.list(3, 10); break;",
		"list 1-,#3": " o.list(3, 1, 65535); break;",
		"list -1,#3": " o.list(3, undefined, 1); break;",
		"list 1-2,#3": " o.list(3, 1, 2); break;",
		"list a": "BasicParser: Expected end of arguments at pos 0-4: list",
		'load "file"': ' o.load("file"); o.vmGoto("directs0"); break;\ncase "directs0":',
		'load "file.scr",&c000': ' o.load("file.scr", -0x4000); o.vmGoto("directs0"); break;\ncase "directs0":',
		"load f$,adr": ' o.load(v.f$, v.adrR); o.vmGoto("directs0"); break;\ncase "directs0":',
		"locate 10,20": " o.locate(0, 10, 20);",
		"locate#2,10,20": " o.locate(2, 10, 20);",
		"locate#stream,x,y": " o.locate(v.streamR, v.xR, v.yR);",
		"a=log(10)": " v.aR = o.log(10);",
		"a=log10(10)": " v.aR = o.log10(10);",
		"a$=lower$(b$)": " v.a$ = o.lower$(v.b$);",
		'a$=lower$("String")': ' v.a$ = o.lower$("String");'
	},
	"mask, max, memory, merge, mid$, min, mod, mode, move, mover": {
		"mask &x10101011": " o.mask(0b10101011);",
		"mask 2^(8-x),1": " o.mask(Math.pow(2, (8 - v.xR)), 1);",
		"mask a,b": " o.mask(v.aR, v.bR);",
		"mask ,b": " o.mask(undefined, v.bR);",
		"a=max(1)": ' v.aR = o.vmAssign("aR", o.max(1));',
		"a=max(1,5)": " v.aR = o.max(1, 5);",
		"a=max(b,c,d)": " v.aR = o.max(v.bR, v.cR, v.dR);",
		'a$=max("abc")': ' v.a$ = o.vmAssign("a$", o.max("abc"));',
		'1 a$=max("abc","d")': "CodeGeneratorJs: Type error in 1 at pos 4-5: =",
		"memory &3fff": " o.memory(0x3fff);",
		"memory adr": " o.memory(v.adrR);",
		'merge "file"': ' o.merge("file"); o.vmGoto("directs0"); break;\ncase "directs0":',
		"merge f$": ' o.merge(v.f$); o.vmGoto("directs0"); break;\ncase "directs0":',
		'a$=mid$("string",3)': ' v.a$ = o.mid$("string", 3);',
		'a$=mid$("string",3,2)': ' v.a$ = o.mid$("string", 3, 2);',
		"a$=mid$(b$,p)": " v.a$ = o.mid$(v.b$, v.pR);",
		"a$=mid$(b$,p,lg)": " v.a$ = o.mid$(v.b$, v.pR, v.lgR);",
		"mid$(a$,2)=b$": ' v.a$ = o.vmAssign("a$", o.mid$Assign(v.a$, 2, undefined, v.b$));',
		"mid$(a$,2,2)=b$": ' v.a$ = o.vmAssign("a$", o.mid$Assign(v.a$, 2, 2, v.b$));',
		'mid$(a$,b%,c!)="string"': ' v.a$ = o.vmAssign("a$", o.mid$Assign(v.a$, v.bI, v.cR, "string"));',
		"a=min(1)": ' v.aR = o.vmAssign("aR", o.min(1));',
		"a=min(1,5)": " v.aR = o.min(1, 5);",
		"a=min(b,c,d)": " v.aR = o.min(v.bR, v.cR, v.dR);",
		'a$=min("abc")': ' v.a$ = o.vmAssign("a$", o.min("abc"));',
		'1 a$=min("abc","d")': "CodeGeneratorJs: Type error in 1 at pos 4-5: =",
		"a=10 mod 3": " v.aR = 10 % 3;",
		"a=b mod -c": " v.aR = o.vmRound(v.bR) % o.vmRound(-(v.cR));",
		"mode 0": " o.mode(0);",
		"mode n+1": " o.mode(v.nR + 1);",
		"move 10,20": " o.move(10, 20);",
		"move -10,-20,7": " o.move(-10, -20, 7);",
		"move 10,20,7,3": " o.move(10, 20, 7, 3);",
		"move 10,20,,3": " o.move(10, 20, undefined, 3);",
		"move x,y,m,g1": " o.move(v.xR, v.yR, v.mR, v.g1R);",
		"mover 10,20": " o.mover(10, 20);",
		"mover -10,-20,7": " o.mover(-10, -20, 7);",
		"mover 10,20,7,3": " o.mover(10, 20, 7, 3);",
		"mover 10,20,,3": " o.mover(10, 20, undefined, 3);",
		"mover x,y,m,g1": " o.mover(v.xR, v.yR, v.mR, v.g1R);"
	},
	"new, next, not": {
		"new": " o.new();",
		"for a=1 to 2: next": ' /* for() */ v.aR = 1; o.vmGoto("directf0b"); break;\ncase "directf0": v.aR += 1;\ncase "directf0b": if (v.aR > 2) { o.vmGoto("directf0e"); break; } /* next("") */ o.vmGoto("directf0"); break;\ncase "directf0e":',
		"for i=1 to 2: next i": ' /* for() */ v.iR = 1; o.vmGoto("directf0b"); break;\ncase "directf0": v.iR += 1;\ncase "directf0b": if (v.iR > 2) { o.vmGoto("directf0e"); break; } /* next("v.iR") */ o.vmGoto("directf0"); break;\ncase "directf0e":',
		"for j=1 to 2:for i=3 to 4: next i,j": ' /* for() */ v.jR = 1; o.vmGoto("directf0b"); break;\ncase "directf0": v.jR += 1;\ncase "directf0b": if (v.jR > 2) { o.vmGoto("directf0e"); break; } /* for() */ v.iR = 3; o.vmGoto("directf1b"); break;\ncase "directf1": v.iR += 1;\ncase "directf1b": if (v.iR > 4) { o.vmGoto("directf1e"); break; } /* next("v.iR") */ o.vmGoto("directf1"); break;\ncase "directf1e":; /* next("v.jR") */ o.vmGoto("directf0"); break;\ncase "directf0e":',
		"a=not 2": " v.aR = ~(2);",
		"a=not -b": " v.aR = ~(o.vmRound(-(v.bR)));"
	},
	"on break ..., on error goto, on gosub, on goto, on sq gosub, openin, openout, or, origin, out": {
		"on break cont": " o.onBreakCont();",
		"10 on break gosub 10": " o.onBreakGosub(10);",
		"on break stop": " o.onBreakStop();",
		"10 on error goto 0": " o.onErrorGoto(0);",
		"10 on error goto 10": " o.onErrorGoto(10);",
		"1 on error goto 0:a=asc(0)": "BasicParser: Expected string in 1 at pos 24-25: 0",
		"1 on error goto 2:a=asc(0)\n2 rem": " o.onErrorGoto(2); v.aR = o.asc(0);\n //",
		'1 on error goto 0:?chr$("A")': "BasicParser: Expected number in 1 at pos 25-26: A",
		'1 on error goto 2:?chr$("A")\n2 rem': ' o.onErrorGoto(2); o.print(0, o.chr$("A"), "\\r\\n");\n //',
		'1 on error goto 0:a$=dec$(b$,"\\    \\")': "BasicParser: Expected number in 1 at pos 26-28: b$",
		'1 on error goto 2:a$=dec$(b$,"\\    \\")\n2 rem': ' o.onErrorGoto(2); v.a$ = o.dec$(v.b$, "\\\\    \\\\");\n //',
		"1 on error goto 0:mask ,": "BasicParser: Operand missing in 1 at pos 23-24: ,",
		"1 on error goto 2:mask ,\n2 rem": " o.onErrorGoto(2); o.mask(undefined);\n //",
		"10 on 1 gosub 10": ' o.onGosub("10g0", 1, 10); break;\ncase "10g0":',
		"10 on x gosub 10,20\n20 rem": ' o.onGosub("10g0", v.xR, 10, 20); break;\ncase "10g0":\n //',
		"10 on x+1 gosub 10,20,20\n20 rem": ' o.onGosub("10g0", v.xR + 1, 10, 20, 20); break;\ncase "10g0":\n //',
		"10 on 1 goto 10": ' o.onGoto("10s0", 1, 10); break;\ncase "10s0":',
		"10 on x goto 10,20\n20 rem": ' o.onGoto("10s0", v.xR, 10, 20); break;\ncase "10s0":\n //',
		"10 on x+1 goto 10,20,20\n20 rem": ' o.onGoto("10s0", v.xR + 1, 10, 20, 20); break;\ncase "10s0":\n //',
		"10 on sq(1) gosub 10": " o.onSqGosub(1, 10);",
		"10 on sq(channel) gosub 10": " o.onSqGosub(v.channelR, 10);",
		'openin "file"': ' o.openin("file"); o.vmGoto("directs0"); break;\ncase "directs0":',
		"openin f$": ' o.openin(v.f$); o.vmGoto("directs0"); break;\ncase "directs0":',
		'openout "file"': ' o.openout("file");',
		"openout f$": " o.openout(v.f$);",
		"a=1 or &1a0": " v.aR = 1 | 0x1a0;",
		"a=b or c": " v.aR = o.vmRound(v.bR) | o.vmRound(v.cR);",
		"origin 10,20": " o.origin(10, 20);",
		"origin 10,20,5,200,50,15": " o.origin(10, 20, 5, 200, 50, 15);",
		"origin x,y,left,right,top,bottom": " o.origin(v.xR, v.yR, v.leftR, v.rightR, v.topR, v.bottomR);",
		"out &bc12,&12": " o.out(-0x43ee, 0x12);",
		"out adr,by": " o.out(v.adrR, v.byR);"
	},
	"paper, peek, pen, pi, plot, plotr, poke, pos, print": {
		"paper 2": " o.paper(0, 2);",
		"paper#stream,p": " o.paper(v.streamR, v.pR);",
		"a=peek(&c000)": " v.aR = o.peek(-0x4000);",
		"a=peek(adr+5)": " v.aR = o.peek(v.adrR + 5);",
		"pen 2": " o.pen(0, 2);",
		"pen 2,1": " o.pen(0, 2, 1);",
		"pen#3,2,1": " o.pen(3, 2, 1);",
		"pen#stream,p,trans": " o.pen(v.streamR, v.pR, v.transR);",
		"a=pi": " v.aR = o.pi();",
		"plot 10,20": " o.plot(10, 20);",
		"plot -10,-20,7": " o.plot(-10, -20, 7);",
		"plot 10,20,7,3": " o.plot(10, 20, 7, 3);",
		"plot 10,20,,3": " o.plot(10, 20, undefined, 3);",
		"plot x,y,m,g1": " o.plot(v.xR, v.yR, v.mR, v.g1R);",
		"plotr 10,20": " o.plotr(10, 20);",
		"plotr -10,-20,7": " o.plotr(-10, -20, 7);",
		"plotr 10,20,7,3": " o.plotr(10, 20, 7, 3);",
		"plotr 10,20,,3": " o.plotr(10, 20, undefined, 3);",
		"plotr x,y,m,g1": " o.plotr(v.xR, v.yR, v.mR, v.g1R);",
		"poke &c000,23": " o.poke(-0x4000, 23);",
		"poke adr,by": " o.poke(v.adrR, v.byR);",
		"a=pos(#0)": " v.aR = o.pos(0);",
		"a=pos(#stream)": " v.aR = o.pos(v.streamR);",
		"print": ' o.print(0, "\\r\\n");',
		"print ,": ' o.print(0, {type: "commaTab", args: []});',
		"print ;": " o.print(0);",
		"print #2": ' o.print(2, "\\r\\n");',
		"print #2,": ' o.print(2, "\\r\\n");',
		'print "string"': ' o.print(0, "string", "\\r\\n");',
		"print 999999999;": " o.print(0, 999999999);",
		"print 1e9;": " o.print(0, 1e9);",
		"print 2.5e10;": " o.print(0, 2.5e10);",
		"print 1.234567846;": " o.print(0, 1.234567846);",
		"print a$": ' o.print(0, v.a$, "\\r\\n");',
		"print a$,b": ' o.print(0, v.a$, {type: "commaTab", args: []}, v.bR, "\\r\\n");',
		"print#2,a$,b": ' o.print(2, v.a$, {type: "commaTab", args: []}, v.bR, "\\r\\n");',
		'print using"####";ri;': ' o.print(0, o.using("####", v.riR));',
		'print using "##.##";-1.2': ' o.print(0, o.using("##.##", -1.2), "\\r\\n");',
		'print using"### ########";a,b': ' o.print(0, o.using("### ########", v.aR, v.bR), "\\r\\n");',
		'print using "\\   \\";"n1";"n2";" xx3";': ' o.print(0, o.using("\\\\   \\\\", "n1", "n2", " xx3"));',
		'print using "!";"a1";"a2";': ' o.print(0, o.using("!", "a1", "a2"));',
		'print using "&";"a1";"a2";': ' o.print(0, o.using("&", "a1", "a2"));',
		'print#9,tab(t);t$;i;"h1"': ' o.print(9, {type: "tab", args: [v.tR]}, v.t$, v.iR, "h1", "\\r\\n");',
		"?": ' o.print(0, "\\r\\n");',
		"?#2,ti-t0!;spc(5);": ' o.print(2, v.tiR - v.t0R, {type: "spc", args: [5]});'
	},
	"rad, randomize, read, release, rem, remain, renum, restore, resume, return, right$, rnd, round, run": {
		"rad": " o.rad();",
		"randomize": ' o.vmGoto("directs0"); break;\ncase "directs0":o.randomize(); o.vmGoto("directs1"); break;\ncase "directs1": o.randomize(o.vmGetNextInput());',
		"randomize 123.456": " o.randomize(123.456);",
		"read a$": ' v.a$ = o.read("a$");',
		"read b": ' v.bR = o.read("bR");',
		"read a$,b,c$": ' v.a$ = o.read("a$"); v.bR = o.read("bR"); v.c$ = o.read("c$");',
		"release 1": " o.release(1);",
		"release n+1": " o.release(v.nR + 1);",
		"rem": " //",
		"rem comment until EOL": " // comment until EOL",
		"rem \\": " // \\",
		"'": " //",
		"'comment until EOL": " // comment until EOL",
		"'\\": " // \\",
		"a=1 'comment": " v.aR = 1; // comment",
		"a=remain(0)": " v.aR = o.remain(0);",
		"a=remain(ti)": " v.aR = o.remain(v.tiR);",
		"renum": ' o.renum(); o.vmGoto("directs0"); break;\ncase "directs0":',
		"renum 100": ' o.renum(100); o.vmGoto("directs0"); break;\ncase "directs0":',
		"renum 100,50": ' o.renum(100, 50); o.vmGoto("directs0"); break;\ncase "directs0":',
		"renum 100,50,2": ' o.renum(100, 50, 2); o.vmGoto("directs0"); break;\ncase "directs0":',
		"restore": " o.restore();",
		"10 restore 10": " o.restore(10);",
		"resume": " o.resume(); break;",
		"10 resume 10": " o.resume(10); break;",
		"resume next": " o.resumeNext(); break;",
		"return": " o.return(); break;",
		"a$=right$(b$,n)": " v.a$ = o.right$(v.b$, v.nR);",
		"a=rnd": " v.aR = o.rnd();",
		"a=rnd(0)": " v.aR = o.rnd(0);",
		"a=rnd(-1*b)": " v.aR = o.rnd(-1 * v.bR);",
		"a=round(2.335)": " v.aR = o.round(2.335);",
		"a=round(2.335,2)": " v.aR = o.round(2.335, 2);",
		"run": ' o.run(); o.vmGoto("directs0"); break;\ncase "directs0":',
		"10 run 10": ' o.run(10); o.vmGoto("10s0"); break;\ncase "10s0":',
		'run "file"': ' o.run("file"); o.vmGoto("directs0"); break;\ncase "directs0":',
		"run f$": ' o.run(v.f$); o.vmGoto("directs0"); break;\ncase "directs0":'
	},
	save: {
		'save "file"': ' o.save("file"); o.vmGoto("directs0"); break;\ncase "directs0":',
		'save "file",p': ' o.save("file", "p"); o.vmGoto("directs0"); break;\ncase "directs0":',
		'save "file",a': ' o.save("file", "a"); o.vmGoto("directs0"); break;\ncase "directs0":',
		'save "file.scr",b,&c000,&4000': ' o.save("file.scr", "b", -0x4000, 0x4000); o.vmGoto("directs0"); break;\ncase "directs0":',
		'save "file.bin",b,&8000,&100,&8010': ' o.save("file.bin", "b", -0x8000, 0x100, -0x7ff0); o.vmGoto("directs0"); break;\ncase "directs0":',
		"save f$,b,adr,lg,entry": ' o.save(v.f$, "b", v.adrR, v.lgR, v.entryR); o.vmGoto("directs0"); break;\ncase "directs0":',
		"a=sgn(5)": " v.aR = o.sgn(5);",
		"a=sgn(0)": " v.aR = o.sgn(0);",
		"a=sgn(-5)": " v.aR = o.sgn(-5);",
		"a=sin(2.3)": " v.aR = o.sin(2.3);",
		"sound 1,100": ' o.sound(1, 100); o.vmGoto("directs0"); break;\ncase "directs0":',
		"sound 1,100,400": ' o.sound(1, 100, 400); o.vmGoto("directs0"); break;\ncase "directs0":',
		"sound 1,100,400,15": ' o.sound(1, 100, 400, 15); o.vmGoto("directs0"); break;\ncase "directs0":',
		"sound 1,100,400,15,1": ' o.sound(1, 100, 400, 15, 1); o.vmGoto("directs0"); break;\ncase "directs0":',
		"sound 1,100,400,15,1,1": ' o.sound(1, 100, 400, 15, 1, 1); o.vmGoto("directs0"); break;\ncase "directs0":',
		"sound 1,100,400,15,1,1,4": ' o.sound(1, 100, 400, 15, 1, 1, 4); o.vmGoto("directs0"); break;\ncase "directs0":',
		"sound ch,period,duration,,,,noise": ' o.sound(v.chR, v.periodR, v.durationR, undefined, undefined, undefined, v.noiseR); o.vmGoto("directs0"); break;\ncase "directs0":',
		"sound ch,period,duration,vol,env1,ent1,noise": ' o.sound(v.chR, v.periodR, v.durationR, v.volR, v.env1R, v.ent1R, v.noiseR); o.vmGoto("directs0"); break;\ncase "directs0":',
		"a$=space$(9)": " v.a$ = o.space$(9);",
		"a$=space$(9+b)": " v.a$ = o.space$(9 + v.bR);",
		"speed ink 10,5": " o.speedInk(10, 5);",
		"speed ink a,b": " o.speedInk(v.aR, v.bR);",
		"speed key 10,5": " o.speedKey(10, 5);",
		"speed key a,b": " o.speedKey(v.aR, v.bR);",
		"speed write 1": " o.speedWrite(1);",
		"speed write a-1": " o.speedWrite(v.aR - 1);",
		"1 speed mode 2": "BasicParser: Expected INK, KEY or WRITE in 1 at pos 8-12: mode",
		"a=sq(1)": " v.aR = o.sq(1);",
		"a=sq(channel)": " v.aR = o.sq(v.channelR);",
		"a=sqr(9)": " v.aR = o.sqr(9);",
		"stop": ' o.stop("directs0"); break;\ncase "directs0":',
		"a$=str$(123)": " v.a$ = o.str$(123);",
		"a$=str$(a+b)": " v.a$ = o.str$(v.aR + v.bR);",
		'a$=string$(40,"*")': ' v.a$ = o.string$(40, "*");',
		"a$=string$(40,42)": " v.a$ = o.string$(40, 42);",
		"a$=string$(lg,char)": " v.a$ = o.string$(v.lgR, v.charR);",
		"symbol 255,1,2,3,4,5,6,7,&x10110011": " o.symbol(255, 1, 2, 3, 4, 5, 6, 7, 0b10110011);",
		"symbol 255,1": " o.symbol(255, 1);",
		"symbol after 255": " o.symbolAfter(255);"
	},
	"tag, tagoff, tan, test, testr, time, troff, tron": {
		"tag": " o.tag(0);",
		"tag#2": " o.tag(2);",
		"tag#stream": " o.tag(v.streamR);",
		"tagoff": " o.tagoff(0);",
		"tagoff#2": " o.tagoff(2);",
		"tagoff#stream": " o.tagoff(v.streamR);",
		"a=tan(45)": " v.aR = o.tan(45);",
		"a=test(10,20)": " v.aR = o.test(10, 20);",
		"a=test(x,y)": " v.aR = o.test(v.xR, v.yR);",
		"a=testr(10,-20)": " v.aR = o.testr(10, -20);",
		"a=testr(xm,ym)": " v.aR = o.testr(v.xmR, v.ymR);",
		"t!=time": " v.tR = o.time();",
		"troff": " o.troff();",
		"tron": ' o.tron(); o.vmGoto("directs0"); break;\ncase "directs0":'
	},
	"unt, upper$": {
		"a=unt(&ff66)": " v.aR = o.unt(-0x9a);",
		'a$=upper$("String")': ' v.a$ = o.upper$("String");',
		"a$=upper$(b$)": " v.a$ = o.upper$(v.b$);"
	},
	"val, vpos": {
		'a=val("-2.3")': ' v.aR = o.val("-2.3");',
		"a=val(b$)": " v.aR = o.val(v.b$);",
		"a=vpos(#0)": " v.aR = o.vpos(0);",
		"a=vpos(#stream)": " v.aR = o.vpos(v.streamR);"
	},
	"wait, wend, while, width, window, window swap, write": {
		"wait &ff34,20": " o.wait(-0xcc, 20);",
		"wait &ff34,20,25": " o.wait(-0xcc, 20, 25);",
		"while a=10: wend": ' \ncase "directw0": if (!(v.aR === 10 ? -1 : 0)) { o.vmGoto("directw0e"); break; } /* o.wend() */ o.vmGoto("directw0"); break;\ncase "directw0e":',
		"while a>0": ' \ncase "directw0": if (!(v.aR > 0 ? -1 : 0)) { o.vmGoto("directw0e"); break; }',
		"width 40": " o.width(40);",
		"window 10,30,5,20": " o.window(0, 10, 30, 5, 20);",
		"window#1,10,30,5,20": " o.window(1, 10, 30, 5, 20);",
		"window#stream,left,right,top,bottom": " o.window(v.streamR, v.leftR, v.rightR, v.topR, v.bottomR);",
		"window swap 1": " o.windowSwap(1);",
		"window swap 1,0": " o.windowSwap(1, 0);",
		"1 window swap #1": "BasicParser: Expected number in 1 at pos 14-15: #",
		"write": " o.write(0);",
		"write #2": " o.write(2);",
		"write #2,": " o.write(2);",
		'write "string"': ' o.write(0, "string");',
		"write 999999999": " o.write(0, 999999999);",
		"write 1e9": " o.write(0, 1e9);",
		"write 2.5e10": " o.write(0, 2.5e10);",
		"write 1.234567846": " o.write(0, 1.234567846);",
		"write a$": " o.write(0, v.a$);",
		"write a$,b": " o.write(0, v.a$, v.bR);",
		"write#2,a$,b": " o.write(2, v.a$, v.bR);",
		"write#2,a$;b": " o.write(2, v.a$, v.bR);",
		"write ,": "BasicParser: Unexpected token at pos 6-7: ,",
		"write ;": "BasicParser: Unexpected token at pos 6-7: ;"
	},
	"xor, xpos": {
		"a=&x1001 xor &x0110": " v.aR = 0b1001 ^ 0b0110;",
		"a=b xor c": " v.aR = o.vmRound(v.bR) ^ o.vmRound(v.cR);",
		"a=xpos": " v.aR = o.xpos();"
	},
	ypos: {
		"a=ypos": " v.aR = o.ypos();"
	},
	zone: {
		"zone 13+n": " o.zone(13 + v.nR);"
	},
	rsx: {
		"|a": ' o.callRsx("a"); o.vmGoto("directs0"); break;\ncase "directs0":',
		"|b": ' o.callRsx("b"); o.vmGoto("directs0"); break;\ncase "directs0":',
		"|basic": ' o.callRsx("basic"); o.vmGoto("directs0"); break;\ncase "directs0":',
		"|cpm": ' o.callRsx("cpm"); o.vmGoto("directs0"); break;\ncase "directs0":',
		'a$="*.drw":|dir,@a$': ' v.a$ = "*.drw"; o.callRsx("dir", o.addressOf("a$")); o.vmGoto("directs0"); break;\ncase "directs0":',
		"|disc": ' o.callRsx("disc"); o.vmGoto("directs0"); break;\ncase "directs0":',
		"|disc.in": ' o.callRsx("disc.in"); o.vmGoto("directs0"); break;\ncase "directs0":',
		"|disc.out": ' o.callRsx("disc.out"); o.vmGoto("directs0"); break;\ncase "directs0":',
		"|drive,0": ' o.callRsx("drive", 0); o.vmGoto("directs0"); break;\ncase "directs0":',
		"1 |drive,": "BasicParser: Expected any parameter for , in 1 at pos 9: ",
		"1 |drive,#1": "BasicParser: Unexpected stream in 1 at pos 9-10: #",
		'|era,"file.bas"': ' o.callRsx("era", "file.bas"); o.vmGoto("directs0"); break;\ncase "directs0":',
		'|ren,"file1.bas","file2.bas"': ' o.callRsx("ren", "file1.bas", "file2.bas"); o.vmGoto("directs0"); break;\ncase "directs0":',
		"|tape": ' o.callRsx("tape"); o.vmGoto("directs0"); break;\ncase "directs0":',
		"|tape.in": ' o.callRsx("tape.in"); o.vmGoto("directs0"); break;\ncase "directs0":',
		"|tape.out": ' o.callRsx("tape.out"); o.vmGoto("directs0"); break;\ncase "directs0":',
		"|user,1": ' o.callRsx("user", 1); o.vmGoto("directs0"); break;\ncase "directs0":',
		"|mode,3": ' o.callRsx("mode", 3); o.vmGoto("directs0"); break;\ncase "directs0":',
		"|renum,1,2,3,4": ' o.callRsx("renum", 1, 2, 3, 4); o.vmGoto("directs0"); break;\ncase "directs0":',
		"|": ' o.callRsx(""); o.vmGoto("directs0"); break;\ncase "directs0":'
	},
	keepSpaces: {
		' 1  chain   merge  "f5"': ' o.chainMerge("f5"); o.vmGoto("1s0"); break;\ncase "1s0":',
		' 1  def   fn  a$ = "abc"': ' v.fna$ = function () { return "abc"; };',
		" 1  for   i   =   1   to  10   step  2": ' /* for() */ v.iR = 1; o.vmGoto("1f0b"); break;\ncase "1f0": v.iR += 2;\ncase "1f0b": if (v.iR > 10) { o.vmGoto("1f0e"); break; }',
		" 1  if    a  =  1     then  1     else    goto  1": " if (v.aR === 1) { o.goto(1); break; } else { o.goto(1); break; }",
		" 1  line   input  a$": ' o.vmGoto("1s0"); break;\ncase "1s0":o.lineInput(0, undefined, "? ", "a$"); o.vmGoto("1s1"); break;\ncase "1s1":; v.a$ = o.vmGetNextInput();',
		" 1  on  break   cont": " o.onBreakCont();",
		" 1  on  break   gosub   1": " o.onBreakGosub(1);",
		" 1  on  break   stop": " o.onBreakStop();",
		" 1  on  error   goto   1": " o.onErrorGoto(1);",
		" 1  on  x  gosub   1  ,  2\n2  rem": ' o.onGosub("1g0", v.xR, 1, 2); break;\ncase "1g0":\n //',
		" 1  on  x  goto   1  ,  2\n2  rem": ' o.onGoto("1s0", v.xR, 1, 2); break;\ncase "1s0":\n //',
		' 1   print   using    "####" ;  ri  ;': ' o.print(0, o.using("####", v.riR));',
		" 1  window   swap  1,0": " o.windowSwap(1, 0);",
		"a=1 else a=2": " v.aR = 1; // else a = 2",
		"a=1 'comment": " v.aR = 1; // comment",
		"a=1 :'comment": " v.aR = 1; // comment",
		"::a=3-2-1: :": " v.aR = (3 - 2) - 1;",
		" a =  ( b% >= c%  ) *     ( d <=e )  ": " v.aR = (v.bI >= v.cI ? -1 : 0) * (v.dR <= v.eR ? -1 : 0);",
		"a = (((3+2))*((3-7)))": " v.aR = (3 + 2) * (3 - 7);"
	},
	PRG: {
		'100 \'Das Raetsel\n110 \'21.5.1988 Kopf um Kopf\n120 \'ab*c=de  de+fg=hi   [dabei sind a-i verschiedene Ziffern 1-9!!]\n130 MODE 1:PRINT"Please wait ...  ( ca. 1 min 34 sec )"\n140 CLEAR:DEFINT a-y\n150 \'\n155 z=TIME\n160 FOR a=1 TO 9:FOR b=1 TO 9:FOR c=1 TO 9:FOR f=1 TO 9:FOR g=1 TO 9\n170 de=(a*10+b)*c:IF de>99 THEN 320\n180 hi=de+(f*10+g):IF hi>99 THEN 320\n190 d=INT(de/10):e=de MOD 10:h=INT(hi/10):i=hi MOD 10\n200 IF a=b OR a=c OR a=d OR a=e OR a=f OR a=g OR a=h OR a=i THEN 320\n210 IF b=c OR b=d OR b=e OR b=f OR b=g OR b=h OR b=i THEN 320\n220 IF c=d OR c=e OR c=f OR c=g OR c=h OR c=i THEN 320\n230 IF d=e OR d=f OR d=g OR d=h OR d=i THEN 320\n240 IF e=f OR e=g OR e=h OR e=i THEN 320\n250 IF f=g OR f=h OR f=i THEN 320\n260 IF g=h OR g=i THEN 320\n270 IF h=i THEN 320\n280 IF i=0 THEN 320\n285 z=TIME-z\n290 CLS:PRINT"Die Loesung:":PRINT\n300 PRINT a*10+b"*"c"="de" / "de"+"f*10+g"="hi\n310 PRINT z,z/300:STOP\n320 NEXT g,f,c,b,a\n': ' // Das Raetsel\n // 21.5.1988 Kopf um Kopf\n // ab*c=de  de+fg=hi   [dabei sind a-i verschiedene Ziffern 1-9!!]\n o.mode(1); o.print(0, "Please wait ...  ( ca. 1 min 34 sec )", "\\r\\n");\n o.clear(); o.vmGoto("140s0"); break;\ncase "140s0": o.defint("a", "y");\n //\n v.zR = o.time();\n /* for() */ o.vmAssertNumberType("a"); v["a" + t.a] = 1; o.vmGoto("160f0b"); break;\ncase "160f0": v["a" + t.a] += 1;\ncase "160f0b": if (v["a" + t.a] > 9) { o.vmGoto("160f0e"); break; } /* for() */ o.vmAssertNumberType("b"); v["b" + t.b] = 1; o.vmGoto("160f1b"); break;\ncase "160f1": v["b" + t.b] += 1;\ncase "160f1b": if (v["b" + t.b] > 9) { o.vmGoto("160f1e"); break; } /* for() */ o.vmAssertNumberType("c"); v["c" + t.c] = 1; o.vmGoto("160f2b"); break;\ncase "160f2": v["c" + t.c] += 1;\ncase "160f2b": if (v["c" + t.c] > 9) { o.vmGoto("160f2e"); break; } /* for() */ o.vmAssertNumberType("f"); v["f" + t.f] = 1; o.vmGoto("160f3b"); break;\ncase "160f3": v["f" + t.f] += 1;\ncase "160f3b": if (v["f" + t.f] > 9) { o.vmGoto("160f3e"); break; } /* for() */ o.vmAssertNumberType("g"); v["g" + t.g] = 1; o.vmGoto("160f4b"); break;\ncase "160f4": v["g" + t.g] += 1;\ncase "160f4b": if (v["g" + t.g] > 9) { o.vmGoto("160f4e"); break; }\n v["de" + t.d] = o.vmAssign("d", ((v["a" + t.a] * 10) + v["b" + t.b]) * v["c" + t.c]); if (v["de" + t.d] > 99) { o.goto(320); break; }\n v["hi" + t.h] = o.vmAssign("h", v["de" + t.d] + ((v["f" + t.f] * 10) + v["g" + t.g])); if (v["hi" + t.h] > 99) { o.goto(320); break; }\n v["d" + t.d] = o.vmAssign("d", o.int(v["de" + t.d] / 10)); v["e" + t.e] = o.vmAssign("e", o.vmRound(v["de" + t.d]) % 10); v["h" + t.h] = o.vmAssign("h", o.int(v["hi" + t.h] / 10)); v["i" + t.i] = o.vmAssign("i", o.vmRound(v["hi" + t.h]) % 10);\n if ((v["a" + t.a] === v["b" + t.b] ? -1 : 0) | ((v["a" + t.a] === v["c" + t.c] ? -1 : 0) | ((v["a" + t.a] === v["d" + t.d] ? -1 : 0) | ((v["a" + t.a] === v["e" + t.e] ? -1 : 0) | ((v["a" + t.a] === v["f" + t.f] ? -1 : 0) | ((v["a" + t.a] === v["g" + t.g] ? -1 : 0) | ((v["a" + t.a] === v["h" + t.h] ? -1 : 0) | (v["a" + t.a] === v["i" + t.i] ? -1 : 0)))))))) { o.goto(320); break; }\n if ((v["b" + t.b] === v["c" + t.c] ? -1 : 0) | ((v["b" + t.b] === v["d" + t.d] ? -1 : 0) | ((v["b" + t.b] === v["e" + t.e] ? -1 : 0) | ((v["b" + t.b] === v["f" + t.f] ? -1 : 0) | ((v["b" + t.b] === v["g" + t.g] ? -1 : 0) | ((v["b" + t.b] === v["h" + t.h] ? -1 : 0) | (v["b" + t.b] === v["i" + t.i] ? -1 : 0))))))) { o.goto(320); break; }\n if ((v["c" + t.c] === v["d" + t.d] ? -1 : 0) | ((v["c" + t.c] === v["e" + t.e] ? -1 : 0) | ((v["c" + t.c] === v["f" + t.f] ? -1 : 0) | ((v["c" + t.c] === v["g" + t.g] ? -1 : 0) | ((v["c" + t.c] === v["h" + t.h] ? -1 : 0) | (v["c" + t.c] === v["i" + t.i] ? -1 : 0)))))) { o.goto(320); break; }\n if ((v["d" + t.d] === v["e" + t.e] ? -1 : 0) | ((v["d" + t.d] === v["f" + t.f] ? -1 : 0) | ((v["d" + t.d] === v["g" + t.g] ? -1 : 0) | ((v["d" + t.d] === v["h" + t.h] ? -1 : 0) | (v["d" + t.d] === v["i" + t.i] ? -1 : 0))))) { o.goto(320); break; }\n if ((v["e" + t.e] === v["f" + t.f] ? -1 : 0) | ((v["e" + t.e] === v["g" + t.g] ? -1 : 0) | ((v["e" + t.e] === v["h" + t.h] ? -1 : 0) | (v["e" + t.e] === v["i" + t.i] ? -1 : 0)))) { o.goto(320); break; }\n if ((v["f" + t.f] === v["g" + t.g] ? -1 : 0) | ((v["f" + t.f] === v["h" + t.h] ? -1 : 0) | (v["f" + t.f] === v["i" + t.i] ? -1 : 0))) { o.goto(320); break; }\n if ((v["g" + t.g] === v["h" + t.h] ? -1 : 0) | (v["g" + t.g] === v["i" + t.i] ? -1 : 0)) { o.goto(320); break; }\n if (v["h" + t.h] === v["i" + t.i]) { o.goto(320); break; }\n if (v["i" + t.i] === 0) { o.goto(320); break; }\n v.zR = o.time() - v.zR;\n o.cls(0); o.print(0, "Die Loesung:", "\\r\\n"); o.print(0, "\\r\\n");\n o.print(0, (v["a" + t.a] * 10) + v["b" + t.b], "*", v["c" + t.c], "=", v["de" + t.d], " / ", v["de" + t.d], "+", (v["f" + t.f] * 10) + v["g" + t.g], "=", v["hi" + t.h], "\\r\\n");\n o.print(0, v.zR, {type: "commaTab", args: []}, v.zR / 300, "\\r\\n"); o.stop("310s0"); break;\ncase "310s0":\n /* next("v["g" + t.g]") */ o.vmGoto("160f4"); break;\ncase "160f4e":; /* next("v["f" + t.f]") */ o.vmGoto("160f3"); break;\ncase "160f3e":; /* next("v["c" + t.c]") */ o.vmGoto("160f2"); break;\ncase "160f2e":; /* next("v["b" + t.b]") */ o.vmGoto("160f1"); break;\ncase "160f1e":; /* next("v["a" + t.a]") */ o.vmGoto("160f0"); break;\ncase "160f0e":'
	}
};
/* eslint-enable quote-props */

// tests added: for with hex and bin constants


type hooksWithCodeGeneratorJs = NestedHooks & {
	codeGeneratorJs: CodeGeneratorJs
};

function createCodeGeneratorJs() {
	const basicParser = new BasicParser({
		quiet: true
	});

	return new CodeGeneratorJs({
		quiet: true,
		lexer: new BasicLexer({
			keywords: basicParser.getKeywords(),
			quiet: true
		}),
		parser: basicParser,
		trace: false,
		noCodeFrame: true
	});
}


QUnit.module("CodeGeneratorJs: Tests", function (hooks) {
	hooks.before(function () {
		(hooks as hooksWithCodeGeneratorJs).codeGeneratorJs = createCodeGeneratorJs();
	});

	function runSingleTest(codeGeneratorJs: CodeGeneratorJs, key: string) {
		const allowDirect = true,
			variables = new Variables({}),
			output = codeGeneratorJs.generate(key, variables, allowDirect),
			result = output.error ? String(output.error) : output.text;

		return result;
	}

	function runTestsFor(category: string, tests: TestsType, assert?: Assert, results?: ResultType) {
		const codeGeneratorJs = (hooks as hooksWithCodeGeneratorJs).codeGeneratorJs;

		for (const key in tests) {
			if (tests.hasOwnProperty(key)) {
				const expected = TestHelper.handleBinaryLiterals(tests[key]),
					result = runSingleTest(codeGeneratorJs, key);

				if (results) {
					results[category].push(TestHelper.stringInQuotes(key) + ": " + TestHelper.stringInQuotes(result));
				}

				if (assert) {
					assert.strictEqual(result, expected, key);
				}
			}
		}
	}

	TestHelper.compareAllTests(TestInput.getAllTests(), allTests);
	TestHelper.generateAllTests(allTests, runTestsFor, hooks);
});
